import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Icon from '../../../common/icons/Icon';
import { sendIntercomEvent } from '../../../common/events';

class VideoTile extends Component {
  static propTypes = {
    video: PropTypes.object.isRequired,
    videoLocation: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    onFavoriteToggle: PropTypes.func,
  };

  getFavoriteIcon() {
    const { video, favoritingEpisode, unfavoritingEpisode, favoritingLibrary, unfavoritingLibrary } = this.props;
    let favoriteActionLoading, unfavoriteActionLoading;

    if (video.get('show_id')) {
      favoriteActionLoading =
        favoritingEpisode.get('episodeId') === video.get('id') && favoritingEpisode.get('loading');
      unfavoriteActionLoading =
        unfavoritingEpisode.get('episodeId') === video.get('id') && unfavoritingEpisode.get('loading');
    } else {
      favoriteActionLoading = favoritingLibrary.get('videoId') === video.get('id') && favoritingLibrary.get('loading');
      unfavoriteActionLoading =
        unfavoritingLibrary.get('videoId') === video.get('id') && unfavoritingLibrary.get('loading');
    }

    if (favoriteActionLoading || unfavoriteActionLoading) {
      return 'Saving';
    }

    return video.get('favorited') ? <Icon icon="Favorite" /> : <Icon icon="UnFavorite" />;
  }

  favoriteToggle = e => {
    const { video, onFavoriteToggle } = this.props;

    const eventPre = video.get('favorited') ? 'unfavorite' : 'favorite';
    const eventSuff = video.get('library_category_section_id') ? 'library' : 'tv';
    const eventName = `${eventPre}_${eventSuff}`;
    sendIntercomEvent(eventName, { videoTitle: video.get('name') });
    onFavoriteToggle(e, video);
  };

  render() {
    const { video, videoLocation, locked } = this.props;

    const favoriteIcon = this.getFavoriteIcon();
    const videoLink = !locked ? (
      <Link className="lib-video" to={videoLocation}>
        <div
          className="lib-video__img-wrapper"
          style={{ backgroundImage: `url(${video.getIn(['image', 'location'])})` }}
        >
          <Icon className="play-icon" icon="PlayCircle" />
        </div>
        <div className="lib-video__info-wrapper">
          <h4>
            {video.get('name')}
            <span className="lib-video--fave" onClick={this.favoriteToggle}>
              {favoriteIcon}
            </span>
          </h4>
          <span>{video.get('description')}</span>
        </div>
      </Link>
    ) : (
      <div className="lib-video lib-video-locked">
        <div
          className="lib-video__img-wrapper"
          style={{ backgroundImage: `url(${video.getIn(['image', 'location'])})` }}
        />
        <div className="lock-wrapper">
          <div className="lock-icon">
            <Icon icon="Lock" />
          </div>
          <div className="lib-video__img-locked-cover" />
          <div className="lib-video__img-locked-tooltip">
            This video is locked until you complete the corresponding course content!
          </div>
        </div>
        <div className="lib-video__info-wrapper">
          <h4>{video.get('name')}</h4>
          <span>{video.get('description')}</span>
        </div>
      </div>
    );

    return videoLink;
  }
}

const mapStateToProps = (state, props) => ({
  favoritingLibrary: state.subscription.favorites.favoritingLibrary,
  unfavoritingLibrary: state.subscription.favorites.unfavoritingLibrary,
  favoritingEpisode: state.subscription.favorites.favoritingEpisode,
  unfavoritingEpisode: state.subscription.favorites.unfavoritingEpisode,
});

export default connect(mapStateToProps)(VideoTile);



// WEBPACK FOOTER //
// ./src/subscription/library/common/VideoTile.js